import { Store, Stethoscope, GraduationCap, Factory, Landmark, Briefcase } from "lucide-react";

const INDUSTRIES = [
  { icon: Store, name: "Retail" },
  { icon: Stethoscope, name: "Healthcare" },
  { icon: GraduationCap, name: "Education" },
  { icon: Factory, name: "Manufacturing" },
  { icon: Landmark, name: "Municipal" },
  { icon: Briefcase, name: "Offices & Professional Services" },
];

export const Industries = () => (
  <section id="industries" data-testid="industries-section" className="bg-white py-20 lg:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
        <div className="max-w-2xl">
          <p className="eyebrow">Industries We Serve</p>
          <h2 className="h2 mt-5">Technology for Every Local Business</h2>
        </div>
        <p className="lead max-w-md">From storefronts to clinics, classrooms and municipal offices, we set up technology that fits the way you work.</p>
      </div>
      <ul className="mt-14 grid grid-cols-2 gap-4 sm:gap-5 md:grid-cols-3 lg:grid-cols-6">
        {INDUSTRIES.map(({ icon: Icon, name }, i) => (
          <li key={name} data-testid={`industry-tile-${i}`} className="group flex flex-col items-center rounded-xl border border-transparent bg-brand-offwhite px-4 py-8 text-center transition-[background-color,border-color,box-shadow,transform] duration-300 hover:border-brand-cyan/30 hover:bg-white hover:shadow-[0_18px_30px_-20px_rgba(7,31,53,0.35)]">
            <span className="grid h-14 w-14 place-items-center rounded-full bg-white transition-colors duration-300 group-hover:bg-brand-surface">
              <Icon className="h-6 w-6 text-brand-blue" strokeWidth={1.6} />
            </span>
            <span className="mt-4 font-heading text-sm font-semibold leading-snug text-brand-navy">{name}</span>
          </li>
        ))}
      </ul>
    </div>
  </section>
);
